import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import RightModalLayout from '../layouts/Modal/RightModalLayout';
import ButtonMC from '../components/ButtonMC';
import pipedreamModelMC from '../models/PipedreamShopModelMC';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';

const PipedreamActions = ({ integration, slug, email }) => {
  const { t } = useTranslation('integrations');
  const dispatch = useDispatch();
  const [syncProducts, setSyncProducts] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const handleSyncProducts = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await pipedreamModelMC.syncProducts({ integration, slug, email });
      showtoast(t(`IntegrationsModuleMC.${integration}.syncProducts.success`));
      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
    } catch (error) {
      console.error('Error syncing products:', error);
      showtoast(error?.message || error);
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <RightModalLayout
        title={t(`IntegrationsModuleMC.${integration}.title`)}
      >
        <div className="tw-p-5 tw-rounded-2xl tw-flex tw-border tw-mt-5">
          <label className="switch tw-w-28">
            <input
              type="checkbox"
              name="syncProducts"
              checked={syncProducts}
              onChange={({ target }) => setSyncProducts(target.checked)}
            />
            <span className="slider round"></span>
          </label>
          <div className="tw-ml-2">
            <p className="tw-font-semibold">{t(`IntegrationsModuleMC.${integration}.syncProducts.title`)}</p>
            <p className="tw-text-sm">
              {t(`IntegrationsModuleMC.${integration}.syncProducts.desc`)}
            </p>
            {syncProducts && (
              <ButtonMC
                text={t(`IntegrationsModuleMC.${integration}.syncProducts.textButton`)}
                className="!tw-px-4 tw-mt-4"
                icon="settings-outline"
                iconPosition="left"
                onClick={handleSyncProducts}
                disabled={loading}
              />
            )}
          </div>
        </div>
      </RightModalLayout>
    </div>
  );
};

export default PipedreamActions;
